import { useQuery } from '@tanstack/react-query'
import { GetV1UsersResponse } from '../client'
import { getV1UsersOptions } from '../client/@tanstack/react-query.gen'
import { ExtendedQueryOptions } from '../types'

export type User = GetV1UsersResponse[number]

export const useUsersByWorkshop = (
  workshopId?: string,
  options?: Partial<ExtendedQueryOptions<User[]>>,
) => {
  return useQuery({
    ...getV1UsersOptions({ query: { workshopId } }),
    ...options,
  })
}

// Includes soft-deleted (deactivated) users alongside active ones.
export const useAllUsersByWorkshop = (
  workshopId?: string,
  options?: Partial<ExtendedQueryOptions<User[]>>,
) => {
  return useQuery({
    ...getV1UsersOptions({ query: { workshopId, includeDeleted: 'true' } }),
    ...options,
  })
}
